import { useEffect } from 'react';
import { useFragment, graphql } from 'react-relay';

import { trackAbTestV2Variant } from 'dibs-buyer-layout/exports/clientABTestV2';
import { useShowPricingGuidance } from 'dibs-pricing-guidance/exports/useShowPricingGuidance';

import { PDP_ESTIMATE_SIMILAR_SOLD_TEST_NAME } from '../../constants/abTestsConstants';

import { type usePdpEstimateSimilarSoldTest_item$key } from './__generated__/usePdpEstimateSimilarSoldTest_item.graphql';

const itemFragment = graphql`
    fragment usePdpEstimateSimilarSoldTest_item on Item {
        ...useShowPricingGuidance_item
    }
`;

export const useTrackPdpEstimateSimilarSoldTest = ({
    item: itemRef,
    currency,
}: {
    item?: usePdpEstimateSimilarSoldTest_item$key | null;
    currency: string;
}): void => {
    const item = useFragment(itemFragment, itemRef);

    const showPricingGuidance = useShowPricingGuidance({ item: item || null, currency });

    useEffect(() => {
        if (showPricingGuidance) {
            trackAbTestV2Variant(PDP_ESTIMATE_SIMILAR_SOLD_TEST_NAME);
        }
    }, [showPricingGuidance]);
};
